import React,{Component} from 'react';
import {formatPrice,formatQuantity} from '../helpers/helpers'

class DisplayDelivery extends Component{

	
          
    render() {
        
        return (
            <tr>
                <td>
                    <p>{formatQuantity(this.props.product.productNumber)}</p>
                    <input type="hidden" ref="productNumber" value={this.props.product.productNumber}/>
                </td>
                <td>
                    <p>{this.props.product.productUnit}</p>
                    <input type="hidden" ref="productUnit" value={this.props.product.productUnit}/>
                </td>
                <td>
                    <p>{this.props.product.productName}</p>
                    <input type="hidden" ref="productName" value={this.props.product.productName}/>
                </td>
                          
              
            </tr>	    
        );
    }
}

export default  DisplayDelivery;


// WEBPACK FOOTER //
// ./src/components/DisplayDelivery.js